import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import FontCase from "%/dynamic-component-editor/options/font-case";
import TextWrap from "%/dynamic-component-editor/options/text-wrap";
import LineHeightMultiplier from "%/dynamic-component-editor/options/line-height-multiplier";
import TextDecoration from "%/dynamic-component-editor/options/text-decoration";
import FontStyle from "%/dynamic-component-editor/options/font-style";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import TextAlign from "%/dynamic-component-editor/options/text-align";
import TextOverflow from "%/dynamic-component-editor/options/text-overflow";
import MaxVerticalLines from "%/dynamic-component-editor/options/max-vertical-lines";

export default class TextOptions extends BaseOptionsBundle {

  optionTitle = "Advanced Typography";
  static optionClassName = "i-dynamic-text";
  inspectorToolGroup = "advanced-text";
  useInspectorLabel = false;

  static userInterfaceComponent = {
    component: inspectorTools.ADVANCED_TEXT_TOOL_SET,
    canSetOtherStates: [BaseOption.$states.HOVER],
  };

  constructor(values = {}, optionTitle = "Text Options") {
    super(values, [
      TextDecoration,
      FontStyle,
      TextWrap,
      TextOverflow,
      MaxVerticalLines,
      TextAlign,
      LineHeightMultiplier,
      FontCase,
    ]);
    this.optionTitle = optionTitle;
  }
}
